module.exports = __webpack_public_path__ + "img/cluster_protection_100px_bluebox.083fb336.png";